export default {
	// acceptLanguage: 'en-US, en',
	// defaultLanguage: 'en',
	alertNum: '',
	// roleList: [],
	// loginFlag: false,
	// userName: '',
	// setAccept(newAccept) {
	// 	this.acceptLanguage = newAccept;
	// },
	setAlertNum(newAlert) {
		this.alertNum = newAlert;
	},
	// setRole(newRole) {
	// 	this.roleList = newRole;
	// },
	// setLanguage(newLanguage) {
	// 	this.defaultLanguage = newLanguage;
	// },
	// setLogin(newLogin) {
	// 	this.loginFlag = newLogin;
	// },
	// setUserName(newName) {
	// 	this.userName = newName;
	// }
}



// WEBPACK FOOTER //
// ./src/global.js